import React from 'react';
import PropTypes from 'prop-types';
import { Prompt } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ViewList from '@mui/icons-material/ViewList';
import { isValid } from '@totalsoft/pure-validations-react';
import RequiredDocumentGeneralDataComponent from './RequiredDocumentGeneralDataComponent';
import { Card, IconButton } from '@totalsoft/rocket-ui';

export const RequiredDocumentGeneralDataCard = ({ requiredDocument, contentTypes, onSave, onPropertyChanged, saving, validation, id }) => {
  const [t] = useTranslation();

  return (
    <Card
      icon={ViewList}
      iconColor='primary'
      title={t('RequiredDocument.GeneralData')}
      actions={
        <IconButton
          type='save'
          fontSize='medium'
          color='transparent'
          tooltip={t('Tooltips.RequiredDocument.SaveChanges')}
          onClick={onSave}
          disabled={!requiredDocument.changed || !(validation |> isValid) || saving}
        />
      }
    >
      <Prompt when={id !== undefined && requiredDocument.changed} message={t('RequiredDocument.LeavingWithoutSavingRequiredDocument')} />
      <RequiredDocumentGeneralDataComponent
        requiredDocument={requiredDocument}
        onPropertyChanged={onPropertyChanged}
        contentTypes={contentTypes}
        validation={validation}
      />
    </Card>
  );
};

RequiredDocumentGeneralDataCard.propTypes = {
  requiredDocument: PropTypes.object.isRequired,
  contentTypes: PropTypes.array.isRequired,
  onSave: PropTypes.func.isRequired,
  onPropertyChanged: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  validation: PropTypes.object.isRequired,
  id: PropTypes.number
};

export default RequiredDocumentGeneralDataCard;
